import { Component, Input } from '@angular/core';

// @example <sp-steps [list]="DemoStepsData" style="light" direction="horizontal" [showDescription]="false"></sp-steps>

@Component({
  selector: 'sp-steps',
  standalone: false,
  templateUrl: './steps.component.html',
  styleUrls: ['./steps.component.scss']

})

// @example of Given Links Object
// [
//   {
//     title: 'Step 1',
//     description: "Step 1 Description",
//     active: true,
//     icon: 'check-circle-2'
//   },
//   {
//     title: 'Step 2',
//     description: "Step 1 Description",
//     active: false,
//     icon: 'check-circle-2'
//   },
//   {
//     title: 'Step 3',
//     description: "Step 1 Description",
//     active: false,
//     icon: 'check-circle-2'
//   }
// ]
export class StepsComponent implements StepsInterface {
  @Input() list: Array<StepList> = [];
  @Input() style: string = 'dark';
  @Input() direction: string = 'vertical'; // horizontal, vertical,
  @Input() showDescription: boolean = false; // horizontal, vertical,

  constructor() {}
}

export interface StepsInterface {
  list: Array<StepList>;
  style: string;
  direction: string;
  showDescription: boolean;
}
export interface StepList {
  title: string;
  description: string;
  active: boolean;
  hidden?: boolean;
  level?: string;
}